


import { mapKeysToCamelCase } from "~/utils/mapKeys";
import { MediaProperties } from "~/modules/cbm";





export enum ReasonParticipantLeft {
    ConferenceEndedViaAPI = "conference_ended_via_api",
    ModeratorEndedConference = "moderator_ended_conference",
    ParticipantUpdatedViaApi = "participant_updated_via_api",
    ParticipantHungUp = "participant_hung_up",
    ParticipantAddFailed = "participant_add_failed"
}





export enum ParticipantCallStatus {
    Init = "init",
    Queued = "queued",
    Connecting = "connecting",
    Connected = "connected",
    Complete = "complete",
    Failed = "failed",
    Busy = "busy",
    NoAnswer = "no-answer",
    Ringing = "ringing",
    InProgress = "in-progress",
    Completed = "completed",
    Canceled = "canceled"
}





export enum StatusCallbackEvent {
    ConferenceStart = "conference-start",
    ConferenceEnd = "conference-end",
    ParticipantJoin = "participant-join",
    ParticipantLeave = "participant-leave",
    ParticipantMute = "participant-mute",
    ParticipantUnmute = "participant-unmute",
    ParticipantModify = "participant-modify",
    ParticipantSpeechStart = "participant-speech-start",
    ParticipantSpeechStop = "participant-speech-stop",
    ParticipantHold = "participant-hold",
    ParticipantUnhold = "participant-unhold"
}





export type VoiceMediaProperties = {
    accountSid: string;
    callSid: string;
    coaching: boolean;
    conferenceSid: string;
    endConferenceOnExit: boolean;
    friendlyName: string;
    hold: boolean;
    muted: boolean;
    sequenceNumber: number;
    timestamp: string;
    startConferenceOnEnter: boolean;
    statusCallbackEvent?: StatusCallbackEvent;
    participantCallStatus?: ParticipantCallStatus;
    reasonParticipantLeft?: ReasonParticipantLeft;
    from?: string;
    to?: string;
} & MediaProperties;

export function toVoiceMediaProperties(mediaProperties: MediaProperties): VoiceMediaProperties {
    const {
        accountSid,
        callSid,
        coaching,
        conferenceSid,
        endConferenceOnExit,
        friendlyName,
        hold,
        muted,
        sequenceNumber: sequenceNumberString,
        timestamp,
        startConferenceOnEnter,
        statusCallbackEvent,
        participantCallStatus,
        reasonParticipantLeft,
        initialParticipantCallSid,
        from,
        to,
        ...otherMediaProperties
    } = mapKeysToCamelCase(mediaProperties) as MediaProperties;
    const sequenceNumber = parseInt(sequenceNumberString?.[0], 10);

    return {
        accountSid: accountSid?.[0],
        callSid: callSid?.[0],
        coaching: coaching?.[0] === "true",
        conferenceSid: conferenceSid?.[0],
        endConferenceOnExit: endConferenceOnExit?.[0] === "true",
        friendlyName: friendlyName?.[0],
        hold: hold?.[0] === "true",
        muted: muted?.[0] === "true",
        sequenceNumber: !Number.isNaN(sequenceNumber) ? sequenceNumber : -1,
        startConferenceOnEnter: startConferenceOnEnter?.[0] === "true",
        statusCallbackEvent: statusCallbackEvent?.[0],
        timestamp: timestamp?.[0],
        participantCallStatus: participantCallStatus?.[0],
        reasonParticipantLeft: reasonParticipantLeft?.[0],
        initialParticipantCallSid: initialParticipantCallSid?.[0],
        from: from?.[0],
        to: to?.[0],
        ...otherMediaProperties
    };
}
